export const openLinkInNewTab = (editor) => {
    editor.on('run:preview', function () {
        const iframe = editor.Canvas.getFrameEl();
        iframe.contentDocument.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', function (event) {
                event.preventDefault();
                window.open(link.href, '_blank');
            });
        });
    });
};
